import epsg28992 from './epsg28992'

export const projections = {
  'EPSG:28992': epsg28992,
}

export function getProjectionConfig(code) {
  const config = projections[code]
  if (!config) {
    throw new Error(`Projection "${code}" not found`)
  }
  return config
}
